import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faHome, faBagShopping, faCartShopping, faBasketShopping,
  faPlusCircle, faCaretDown, faCaretRight, faDashboard, faGear, faCoins,faRectangleList,faCaretLeft
} from '@fortawesome/free-solid-svg-icons';
import { useLocation, useNavigate } from 'react-router-dom';

function useMediaQuery(query) {
  const [matches, setMatches] = useState(false);

  useEffect(() => {
    const media = window.matchMedia(query);
    if (media.matches !== matches) {
      setMatches(media.matches);
    }
    const listener = () => setMatches(media.matches);
    window.addEventListener("resize", listener);
    return () => window.removeEventListener("resize", listener);
  }, [matches, query]);

  return matches;
}

const MSidebar = ({ isOpen, toggleSidebar }) => {
  const isMobile = useMediaQuery('(max-width: 768px)');
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [Items, setItems] = useState(false);
  const [Sales, setSales] = useState(false);
  const [Purchases, setPurchases] = useState(false);
  const [Reports, setReports] = useState(false);
  const [Settings, setSettings] = useState(false);
  const [QuickBuy, setQuickBuy] = useState(false);
  const [Buildcoins, setBuildcoins] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const roleId = parseInt(sessionStorage.getItem('roleId'), 10);

  // useEffect(() => {
  //   setIsCollapsed(isMobile);
  // }, [isMobile]);

  const toggleCollapse = () => {
    setIsCollapsed(!isCollapsed);
  };

  useEffect(() => {
  if (isMobile) {
    setIsCollapsed(false); // always expanded on mobile
  } else {
    setIsCollapsed(false); // default collapsed on desktop
  }
}, [isMobile]);


  const shouldShowMenuItem = (menuItem) => {
    switch (roleId) {
      case 0:
        return true; // All menu items visible
      case 7:
        return menuItem === 'Home';
      default:
        return menuItem === 'Home'; // For any other roleId, show only Home
    }
  };

  const menu = {
    Home: 1, Items: 2, Sales: 4, Purchases: 5, Reports: 6, Settings: 9, QuickBuy: 10, Buildcoins: 11,
  };

  const handleMenuClick = (menu, submenu) => {
    if (isMobile) {
      toggleSidebar(); // Close sidebar on mobile
    }

    // Navigation logic based on menu and submenu
    if (menu === 1) {
      navigate('/mfr/app/mdc');
    } else if (menu === 2) {
      // Handle Items submenu navigation
      // Add your submenu navigation logic here
    } else if (menu === 4) {
      // Handle Sales submenu navigation
      // Add your submenu navigation logic here
    } else if (menu === 5) {
      // Handle Purchases submenu navigation
      // Add your submenu navigation logic here
    } else if (menu === 6) {
      // Handle Reports submenu navigation
      // Add your submenu navigation logic here
    } else if (menu === 9) {
      // Handle Settings submenu navigation
      // Add your submenu navigation logic here
    } else if (menu === 10) {
      // Handle QuickBuy submenu navigation
      // Add your submenu navigation logic here
    } else if (menu === 11) {
      // Handle Buildcoins submenu navigation
      // Add your submenu navigation logic here
    }
  };

  return (
<div
  className={`flex flex-col text-[0.8125rem] bg-[#f7f7fe] border-l font-normal z-[999]
    ${isMobile
      ? (isOpen 
          ? 'fixed top-[3rem] right-0 w-[30%] h-[40%] shadow-lg rounded-l-lg' 
          : 'hidden') 
      : (isCollapsed ? 'w-[3.5rem]' : 'w-[12.5rem]')}`}
>
      <div className={`flex flex-col flex-1 w-full rounded-md`}>
        <div className="flex-grow">
          <ul className="flex flex-col space-y-3 px-2 list-none h-full mt-4 text-[#181C2E]">
            {shouldShowMenuItem('Home') && (
              <li onClick={() => handleMenuClick(menu.Home)}
                  className={`flex flex-row space-x-3 items-center py-2 rounded-l-md cursor-pointer ${location.pathname.includes('/home') ? 'bg-[#f7525A] text-white' : 'hover:bg-[#EDEDF7]'}`}>
                <FontAwesomeIcon icon={faHome} className="ml-2 mr-2" />
                {!isCollapsed && <span>Home</span>}
              </li>
            )}
{/*             {shouldShowMenuItem('Items') && (
              <li className={`flex flex-row space-x-3 items-center py-2 hover:bg-[#EDEDF7] rounded-l-md cursor-pointer ${Items ? 'bg-[#EDEDF7] text-[#f7525A]' : ''}`}
                  onClick={() => { setItems(!Items); toggleCollapse(); }}>
                <FontAwesomeIcon icon={faBagShopping} className="ml-2 mr-2" />
                {!isCollapsed && <span>Items</span>}
                {!isCollapsed && (
                  <FontAwesomeIcon icon={Items ? faCaretDown : faCaretRight} className="ml-auto" />
                )}
              </li>
            )}
            {Items && (
              <ul className="flex flex-col space-y-2">
                <li className="flex flex-row justify-between items-center p-2 cursor-pointer hover:bg-[#EDEDF7]"
                    onClick={() => handleMenuClick(menu.Items, 1)}>
                  <span className="ml-6">Item Categories</span>
                </li>
                <li className="flex flex-row justify-between items-center p-2 cursor-pointer hover:bg-[#EDEDF7]"
                    onClick={() => handleMenuClick(menu.Items, 2)}>
                  <span className="ml-6">Item Groups</span>
                </li>
                <li className="flex flex-row justify-between items-center p-2 cursor-pointer hover:bg-[#EDEDF7]"
                    onClick={() => handleMenuClick(menu.Items, 3)}>
                  <span className="ml-6">Items</span>
                </li>
              </ul>
            )}
            {shouldShowMenuItem('Sales') && (
              <li className={`flex flex-row space-x-3 items-center py-2 hover:bg-[#EDEDF7] rounded-l-md cursor-pointer ${Sales ? 'bg-[#EDEDF7] text-[#f7525A]' : ''}`}
                  onClick={() => { setSales(!Sales); toggleCollapse(); }}>
                <FontAwesomeIcon icon={faCartShopping} className="ml-2 mr-2" />
                {!isCollapsed && <span>Sales</span>}
                {!isCollapsed && (
                  <FontAwesomeIcon icon={Sales ? faCaretDown : faCaretRight} className="ml-auto" />
                )}
              </li>
            )}
            {Sales && (
              <ul className="flex flex-col space-y-2">
                <li className="flex flex-row justify-between items-center p-2 cursor-pointer hover:bg-[#EDEDF7]"
                    onClick={() => handleMenuClick(menu.Sales, 1)}>
                  <span className="ml-6">Customers</span>
                </li>
                <li className="flex flex-row justify-between items-center p-2 cursor-pointer hover:bg-[#EDEDF7]"
                    onClick={() => handleMenuClick(menu.Sales, 2)}>
                  <span className="ml-6">Quotes</span>
                </li>
              </ul>
            )}
            {shouldShowMenuItem('Purchases') && (
              <li className={`flex flex-row space-x-3 items-center py-2 hover:bg-[#EDEDF7] rounded-l-md cursor-pointer ${Purchases ? 'bg-[#EDEDF7] text-[#f7525A]' : ''}`}
                  onClick={() => { setPurchases(!Purchases); toggleCollapse(); }}>
                <FontAwesomeIcon icon={faBasketShopping} className="ml-2 mr-2" />
                {!isCollapsed && <span>Purchases</span>}
                {!isCollapsed && (
                  <FontAwesomeIcon icon={Purchases ? faCaretDown : faCaretRight} className="ml-auto" />
                )}
              </li>
            )}
            {Purchases && (
              <ul className="flex flex-col space-y-2">
                <li className="flex flex-row justify-between items-center p-2 cursor-pointer hover:bg-[#EDEDF7]"
                    onClick={() => handleMenuClick(menu.Purchases, 1)}>
                  <span className="ml-6">Vendors</span>
                </li>
                <li className="flex flex-row justify-between items-center p-2 cursor-pointer hover:bg-[#EDEDF7]"
                    onClick={() => handleMenuClick(menu.Purchases, 2)}>
                  <span className="ml-6">Purchase Orders</span>
                </li>
              </ul>
            )}
            {shouldShowMenuItem('Reports') && (
              <li className={`flex flex-row space-x-3 items-center py-2 hover:bg-[#EDEDF7] rounded-l-md cursor-pointer ${Reports ? 'bg-[#EDEDF7] text-[#f7525A]' : ''}`}
                  onClick={() => { setReports(!Reports); toggleCollapse(); }}>
                <FontAwesomeIcon icon={faRectangleList} className="ml-2 mr-2" />
                {!isCollapsed && <span>Reports</span>}
                {!isCollapsed && (
                  <FontAwesomeIcon icon={Reports ? faCaretDown : faCaretRight} className="ml-auto" />
                )}
              </li>
            )}
            {Reports && (
              <ul className="flex flex-col space-y-2">
                <li className="flex flex-row justify-between items-center p-2 cursor-pointer hover:bg-[#EDEDF7]"
                    onClick={() => handleMenuClick(menu.Reports, 1)}>
                  <span className="ml-6">Sales Order Reports</span>
                </li>
                <li className="flex flex-row justify-between items-center p-2 cursor-pointer hover:bg-[#EDEDF7]"
                    onClick={() => handleMenuClick(menu.Reports, 2)}>
                  <span className="ml-6">Purchase Reports</span>
                </li>
              </ul>
            )}
            {shouldShowMenuItem('Settings') && (
              <li className={`flex flex-row space-x-3 items-center py-2 hover:bg-[#EDEDF7] rounded-l-md cursor-pointer ${Settings ? 'bg-[#EDEDF7] text-[#f7525A]' : ''}`}
                  onClick={() => { setSettings(!Settings); toggleCollapse(); }}>
                <FontAwesomeIcon icon={faGear} className="ml-2 mr-2" />
                {!isCollapsed && <span>Settings</span>}
                {!isCollapsed && (
                  <FontAwesomeIcon icon={Settings ? faCaretDown : faCaretRight} className="ml-auto" />
                )}
              </li>
            )}
            {Settings && (
              <ul className="flex flex-col space-y-2">
                <li className="flex flex-row justify-between items-center p-2 cursor-pointer hover:bg-[#EDEDF7]"
                    onClick={() => handleMenuClick(menu.Settings, 1)}>
                  <span className="ml-6">Organizations</span>
                </li>
                <li className="flex flex-row justify-between items-center p-2 cursor-pointer hover:bg-[#EDEDF7]"
                    onClick={() => handleMenuClick(menu.Settings, 2)}>
                  <span className="ml-6">Templates</span>
                </li>
              </ul>
            )}
            {shouldShowMenuItem('QuickBuy') && (
              <li className={`flex flex-row space-x-3 items-center py-2 hover:bg-[#EDEDF7] rounded-l-md cursor-pointer ${QuickBuy ? 'bg-[#EDEDF7] text-[#f7525A]' : ''}`}
                  onClick={() => { setQuickBuy(!QuickBuy); toggleCollapse(); }}>
                <FontAwesomeIcon icon={faCoins} className="ml-2 mr-2" />
                {!isCollapsed && <span>Quick Buy</span>}
                {!isCollapsed && (
                  <FontAwesomeIcon icon={QuickBuy ? faCaretDown : faCaretRight} className="ml-auto" />
                )}
              </li>
            )}
            {QuickBuy && (
              <ul className="flex flex-col space-y-2">
                <li className="flex flex-row justify-between items-center p-2 cursor-pointer hover:bg-[#EDEDF7]"
                    onClick={() => handleMenuClick(menu.QuickBuy, 1)}>
                  <span className="ml-6">Supplier Products</span>
                </li>
                <li className="flex flex-row justify-between items-center p-2 cursor-pointer hover:bg-[#EDEDF7]"
                    onClick={() => handleMenuClick(menu.QuickBuy, 2)}>
                  <span className="ml-6">Live Orders</span>
                </li>
              </ul>
            )}
            {shouldShowMenuItem('Buildcoins') && (
              <li className={`flex flex-row space-x-3 items-center py-2 hover:bg-[#EDEDF7] rounded-l-md cursor-pointer ${Buildcoins ? 'bg-[#EDEDF7] text-[#f7525A]' : ''}`}
                  onClick={() => { setBuildcoins(!Buildcoins); toggleCollapse(); }}>
                <FontAwesomeIcon icon={faCoins} className="ml-2 mr-2" />
                {!isCollapsed && <span>Buildcoins</span>}
                {!isCollapsed && (
                  <FontAwesomeIcon icon={Buildcoins ? faCaretDown : faCaretRight} className="ml-auto" />
                )}
              </li>
            )}
            {Buildcoins && (
              <ul className="flex flex-col space-y-2">
                <li className="flex flex-row justify-between items-center p-2 cursor-pointer hover:bg-[#EDEDF7]"
                    onClick={() => handleMenuClick(menu.Buildcoins, 1)}>
                  <span className="ml-6">Buildcoin Rules</span>
                </li>
                <li className="flex flex-row justify-between items-center p-2 cursor-pointer hover:bg-[#EDEDF7]"
                    onClick={() => handleMenuClick(menu.Buildcoins, 2)}>
                  <span className="ml-6">Buildcoin Ledgers</span>
                </li>
              </ul>
            )} */}
          </ul>
        </div>
      </div>

      {isMobile && isOpen && (
  <ul className="flex flex-col space-x-3 px-2 list-none text-[#181C2E]">
    <li
      onClick={() => {
        sessionStorage.clear();
        toggleSidebar();
        navigate('/manufacturer'); // redirect to login
      }}
      className="flex flex-row space-x-3 items-center py-2 rounded-l-md cursor-pointer hover:bg-[#EDEDF7] text-[#f7525A] font-semibold"
    >
      {/* <FontAwesomeIcon icon={faCaretLeft} className="ml-2 mr-2" /> */}
      <span>Logout</span>
    </li>
  </ul>
)}

{!isMobile && (
  <div
    className="flex justify-center h-[2rem] bg-[#ededf7] items-center cursor-pointer"
    onClick={toggleCollapse}
  >
    {isCollapsed ? <FontAwesomeIcon icon={faCaretRight} /> : <FontAwesomeIcon icon={faCaretLeft} />}
  </div>
)}


    </div>
  );
};

export default MSidebar;
